"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createReducerManager = createReducerManager;
exports.default = void 0;
var _redux = require("redux");
function createReducerManager() {
  let initialReducers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    noop: function () {
      let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return state;
    }
  };
  // Create an object which maps keys to reducers
  const reducers = {
    ...initialReducers
  };
  const rootReducers = [];
  const options = {
    onAdd: function () {}
  };

  // Create the initial combinedReducer
  let combinedReducer = (0, _redux.combineReducers)(reducers);

  // An array which is used to delete state keys when reducers are removed
  let keysToRemove = [];
  return {
    configure: function (newOptions) {
      Object.assign(options, newOptions);
    },
    getReducerMap: function () {
      return reducers;
    },
    // The root reducer function exposed by this object
    // This will be passed to the store
    reduce: function (state, action) {
      // If any reducers have been removed, clean up their state first
      if (keysToRemove.length > 0) {
        state = {
          ...state
        };
        for (let key of keysToRemove) {
          delete state[key];
        }
        keysToRemove = [];
      }
      let newState = {
        ...state
      };
      rootReducers.forEach(function (reducer) {
        newState = reducer(newState, action);
      });

      // Delegate to the combined reducer
      return combinedReducer(newState, action);
    },
    // Adds a new reducer with the specified key
    add: function (key, reducer) {
      if (!key || reducers[key]) {
        return;
      }

      // Add the reducer to the reducer mapping
      reducers[key] = reducer;

      // Generate a new combined reducer
      combinedReducer = (0, _redux.combineReducers)(reducers);
      if (options.onAdd) {
        options.onAdd(key);
      }
    },
    addRootReducer: function (reducer) {
      rootReducers.push(reducer);
    },
    // Removes a reducer with the specified key
    remove: function (key) {
      if (!key || !reducers[key]) {
        return;
      }

      // Remove it from the reducer mapping
      delete reducers[key];

      // Add the key to the list of keys to clean up
      keysToRemove.push(key);

      // Generate a new combined reducer
      combinedReducer = (0, _redux.combineReducers)(reducers);
    }
  };
}
var _default = exports.default = createReducerManager();